import React from "react";

export const useForgotPassword = () => {
  function onSubmitForm(data: any) {
    throw new Error("Aprecisa ser implementado");
  }

  return { onSubmitForm };
};
